export type GmSection =
  | "overview"
  | "settings"
  | "monsters"
  | "parts"
  | "shop"
  | "dungeonShop"
  | "tower"
  | "users"
  | "events"
  | "drops"
  | "rankBadges"
  | "homeRail"
  | "control";

export const GM_SECTIONS: readonly GmSection[] = [
  "overview",
  "settings",
  "monsters",
  "parts",
  "shop",
  "dungeonShop",
  "tower",
  "users",
  "events",
  "drops",
  "rankBadges",
  "homeRail",
  "control",
];

export function normalizeAppPath(pathname: string): string {
  const path = pathname.replace(/\/+$/, "") || "/";
  return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
}

export function isGmAppPath(pathname: string): boolean {
  const path = normalizeAppPath(pathname);
  return path === "/gm" || path.startsWith("/gm/");
}

export function gmPathForSection(section: GmSection): string {
  return section === "overview" ? "/gm" : `/gm/${section}`;
}

export function parseGmSectionFromPath(pathname: string): GmSection {
  const path = normalizeAppPath(pathname);
  if (path === "/gm") return "overview";
  if (!path.startsWith("/gm/")) return "overview";
  const slug = path.slice("/gm/".length);
  if (!slug || slug.includes("/")) return "overview";
  return (GM_SECTIONS as readonly string[]).includes(slug) ? (slug as GmSection) : "overview";
}

const GM_TOWER_FLOOR_PATH = /^\/gm\/tower\/floor\/(\d+)$/;

export function parseGmTowerFloorFromPath(pathname: string): number | null {
  const path = normalizeAppPath(pathname);
  const match = GM_TOWER_FLOOR_PATH.exec(path);
  if (!match) return null;
  const floor = Math.floor(Number(match[1]));
  if (!Number.isFinite(floor) || floor < 1 || floor > 100) return null;
  return floor;
}

export function gmTowerFloorEditorPath(floor: number): string {
  const f = Math.min(100, Math.max(1, Math.floor(floor)));
  return `/gm/tower/floor/${f}`;
}

export function openGmTowerFloorEditor(floor: number): void {
  window.open(gmTowerFloorEditorPath(floor), "_blank", "noopener,noreferrer");
}
